import React, { FC } from 'react'
import { ExclamationCircleIcon } from '@heroicons/react/solid'
import { Link } from 'react-router-dom'
import { useDraftError } from '../../utils/useDraftError'
import useDraft from '../../../redux/draft-drawer/useDraft'
import ROUTES from '../../utils/routes'
import { StyledDraftDrawerErrorBanner } from '.'

const DraftDrawerErrorBanner: FC = () => {
  const { _id, postDate, socialProfiles } = useDraft()
  const { errors } = useDraftError({ _id, postDate, socialProfiles })

  if (!errors?.length) {
    return <></>
  }

  return (
    <StyledDraftDrawerErrorBanner>
      {errors.map((error) => (
        <Link to={ROUTES.user.settings.profile} className="banner-header">
          <div className="banner-header-icon">
            <ExclamationCircleIcon />
          </div>
          <span>{error}</span>
        </Link>
      ))}
    </StyledDraftDrawerErrorBanner>
  )
}

export default DraftDrawerErrorBanner
